import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
// Models
import { EventSubscriptionType, EventType, EventModel } from '../../../../shared/interfaces/event.model';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
// Services
import { UnitsService } from '../../../../services/units.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { SwalService } from '../../../../shared/services/swal.service';
// Components
import { UnidadesEditCreateComponent } from './modal/edit-create/edit-create.component';



@Component({
    templateUrl: './unidades.component.html',
    styleUrls: ['./unidades.component.scss']
})
export class UnidadesComponent implements OnInit, OnDestroy {
    data: any[] = [];

    dtConfig = {
        config: {
            base: this.unitsService,
            api: 'datatable',
            rowsPerPage: 15,
            order: [[2, 'desc']]
        },
        columns: [
            {
                title: 'ID',
                field: 'id'
            },
            {
                title: 'Nombre',
                field: 'name'
            },
            {
                title: 'Ruta',
                field: 'route.name',
                default: 'No asignada'
            },
            {
                title: 'Activo',
                field: 'active',
                type: 'boolean'
            }
        ],
        actions: [
            {
                display: 'Editar',
                icon: 'fa-pencil',
                event: 'units.edit',
                conditionality: 'true'
            },
            {
                display: 'Eliminar',
                icon: 'fa-trash',
                event: 'units.delete',
                conditionality: 'true'
            }
        ]
    };

    bc$: any;

    constructor(
        public modalRef: BsModalService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private broadcast: BroadcastService,
        private nrModal: NRModalService,
        private swal: SwalService,
        private unitsService: UnitsService
    ) { }

    ngOnDestroy(): void {
        if (this.bc$) {
            this.bc$();
        }
    }

    loadUnits() {
        this.unitsService.getUnits().subscribe({
        next: (response: any) => {
            console.log(response)
            this.data = response; // aquí tienes los datos
        },
        error: (err) => {
            console.error('Error al obtener unidades', err);
        }
        });
    }


    ngOnInit(): void {
        this.bc$ = this.broadcast.on(EventSubscriptionType.TYPE, EventType.MODAL, (event: EventModel) => {
            const props = this.prepareProps(event);
            if (props) {
                this.nrModal.open(props);
            }
        });
    }

    prepareProps(event: EventModel): any {
        const props: DynamicHostModel = new DynamicHostModel;
        props.instantiated = false;
        props.modalModel = {
            component: null,
            componentFactoryResolver: this.componentFactoryResolver,
            data: event.data.item || {}
        };

        switch (event.name) {
            case 'units.add':
                props.modalModel.component = UnidadesEditCreateComponent;
                props.modalModel.modalConfiguration = {
                    title: 'Agregar Unidad'
                };
                break;

            case 'units.edit':
                props.modalModel.component = UnidadesEditCreateComponent;
                props.modalModel.modalConfiguration = {
                    title: 'Editar Unidad'
                };
                break;

            case 'units.delete':
                this.delete(event.data);
                return false;
                break;
        }

        return props;
    }

    /**
   * 
   */
    add(): void {
        this.broadcast.fire({
            name: 'units.add',
            type: EventType.MODAL,
            data: {}
        });
    }

    /**
     * 
     * @param data 
     */
    delete(data): void {
        const swalParams = {
            title: `¿Estás seguro de querer eliminar el código ${data.item.name}?`
        };

        this.swal.warning(swalParams).then(result => {
            if (result.value) {
                this.unitsService.delete(data.item.id).subscribe((resp: any) => {
                    if (resp.success) {
                        this.swal.success({ title: 'Código de error eliminado exitosamente' }).then(() => {
                            this.modalRef.hide(0);
                            this.broadcast.reloadDataTable();
                        });
                    } else {
                        this.swal.error('Ocurrio un error al intentar borrar el código de error');
                    }
                });
            }
        });
    }
}
